exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cursor {\n  cursor: pointer;\n}\n\n.incidentId {\n  color: #000 !important;\n  text-decoration: underline;\n}", ""]);

